export const generateID = () => crypto.randomUUID();
export const generateNumericID = () => {
  const random1 = Math.floor(Math.random() * 1_000_000);
  const random2 = Math.floor(Math.random() * 1_000_000);
  const random3 = Math.floor(Math.random() * 1_000_000);
  return Number.parseInt(`${random1}${random2}${random3}`);
};
